import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import OutlinedInput from '@mui/material/OutlinedInput'

export const SearchContainer = styled(Box)({
  alignItems: 'center',
  justifyContent: 'flex-end',
  display: 'flex',
  height: '72px',
})

export const StyledInput = styled(OutlinedInput)(({ theme }) => ({
  marginLeft: 12,
  '& fieldset': {
    border: `1px solid ${theme.palette.grey[300]}`, //theme.GREY_VARIANT
  },
}))

export const IconWrapper = styled(Box)(({ theme }) => ({
  color: theme.palette.text.secondary,
}))

export const FilterWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})
